import { onLCP, onCLS, onINP } from 'web-vitals/attribution'

function drop (rate) {
  return Math.floor(Math.random() * rate) !== 0
}

function round (value) {
  return value == null ? undefined : Math.round(value)
}

function lcpAttribution ({ target, url, timeToFirstByte, resourceLoadDelay, resourceLoadDuration, elementRenderDelay }) {
  return {
    target,
    url,
    timeToFirstByte: round(timeToFirstByte),
    resourceLoadDelay: round(resourceLoadDelay),
    resourceLoadDuration: round(resourceLoadDuration),
    elementRenderDelay: round(elementRenderDelay)
  }
}

function clsAttribution ({ largestShiftTarget, largestShiftValue, loadState }) {
  return {
    largestShiftTarget,
    largestShiftValue: largestShiftValue == null ? undefined : parseFloat(largestShiftValue.toFixed(4)),
    loadState
  }
}

function inpAttribution ({ interactionTarget, interactionType, loadState, inputDelay, processingDuration, presentationDelay, longAnimationFrameEntries = [] }) {
  const slowestScript = longAnimationFrameEntries
    .flatMap(entry => entry.scripts)
    .sort((a, b) => b.duration - a.duration)[0]

  return {
    interactionTarget,
    interactionType,
    loadState,
    inputDelay: round(inputDelay),
    processingDuration: round(processingDuration),
    presentationDelay: round(presentationDelay),
    slowestScriptUrl: slowestScript?.sourceURL,
    slowestScriptInvoker: slowestScript?.invoker,
    slowestScriptDuration: round(slowestScript?.duration)
  }
}

function trackWebVital (buildAttribution) {
  return ({ name, value, attribution }) => {
    global.dataLayer.push({
      event: 'trackable event',
      eventName: 'Web Vital',
      eventParams: {
        name,
        value: name === 'CLS' ? parseFloat(value.toFixed(4)) : Math.round(value),
        attribution: buildAttribution(attribution)
      }
    })
  }
}

function initWebVitalTracking () {
  if (drop(10)) return

  onLCP(trackWebVital(lcpAttribution))
  onCLS(trackWebVital(clsAttribution))
  onINP(trackWebVital(inpAttribution))
}

initWebVitalTracking()
